export default __webpack_public_path__ + "static/media/time.76896a53.svg";